var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.stbo0{fill:url(#Backgroundbo_13_);}\n\t.stbo3{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Symbols_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphics-_x2F_-App-Icons-_x2F_-iBooks"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iBooks-Icon"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(60 0 0 -60 18231 44901)",
    gradientUnits: "userSpaceOnUse",
    id: "Backgroundbo_13_",
    x1: -303.0167,
    x2: -303.0167,
    y1: 748.2667,
    y2: 746.7667
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFA700"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9661E"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stbo0",
    d: "M63.6,5c9,0,13.6,0,18.4,1.5c5.3,1.9,9.5,6.1,11.4,11.4C95,22.8,95,27.3,95,36.4v27.2     c0,9,0,13.6-1.5,18.4c-1.9,5.3-6.1,9.5-11.4,11.4C77.2,95,72.7,95,63.6,95H36.4c-9,0-13.6,0-18.4-1.5C12.7,91.5,8.5,87.3,6.5,82     C5,77.2,5,72.7,5,63.6V36.4c0-9,0-13.6,1.5-18.4C8.5,12.7,12.7,8.5,18,6.5C22.8,5,27.3,5,36.4,5H63.6z",
    id: "Background_4_"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stbo3",
    d: "M20,32.8c0,0,2.9-7.5,14.6-7.5c11.6,0,14.7,9.8,14.7,9.8v42c0,0-3.7-11.2-14.6-11.2     c-7.9,0-13.5,5.1-13.5,5.1c-0.6,0.5-1.2,0.2-1.2-0.6V32.8z M80,32.8v37.5c0,0.8-0.5,1.1-1.2,0.6c0,0-5.6-5.1-13.5-5.1     C54.5,65.8,50.8,77,50.8,77V35c0,0,3-9.8,14.7-9.8C77.1,25.2,80,32.8,80,32.8z",
    id: "Icon_3_"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.751b8734a7566ff5d89c04f9f69e63fa.svg";
export { ForwardRef as ReactComponent };